import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-card bf-chart-card" }
const _hoisted_2 = { class: "chart activeCoursesChart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoughnutChart = _resolveComponent("DoughnutChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bf-chart-card__head" }, [
      _createElementVNode("div", { class: "bf-chart-card__title" }, "Registros por integração"),
      _createElementVNode("div", { class: "bf-chart-card__subtitle" }, "% do total no período")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DoughnutChart, {
        data: _ctx.chartData,
        options: _ctx.chartOptions
      }, null, 8, ["data", "options"])
    ])
  ]))
}